import { IImageData } from "src/libs/interfaces/layouts"
import { getCssDemention } from "src/libs/utilities"
import { IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"

export default function backgroundSize ( 
    div: IImageData, 
    img: IImageData, 
    position: IScreenPosition, 
    approximation: number = 0, 
    isImportant: boolean = false, 
    isLabel: boolean = false 
): string {
    let str : string = 'background-size: cover;', width: string, height: string
    
    //console.log( div )

    const getWidth = () : string => { 
        height = "auto"
        width = !approximation
            ?
            getCssDemention( position.width )
            :
            `calc(${ getCssDemention( position.width ) } ${ approximation > 0 ? "+" : "-" } ${ Math.abs( approximation ) }px)` 
        return  isLabel
            ?
            getCssDemention( position.width )
            :
            `background-size: ${ width } ${ height }${isImportant ? "!important" : ""};`
    }

    const getHeight = ():string => {
        width = "auto" 
        height = !approximation
            ?
            getCssDemention( position.height )
            :
            `calc(${ getCssDemention( position.height ) } ${ approximation > 0 ? "+" : "-" } ${ Math.abs( approximation ) }px)` 
        return isLabel
            ?
            getCssDemention( position.height )
            :
            `background-size: ${ width } ${ height }${isImportant ? "!important" : ""};`
    }

    const widthFirst = (): string => {
        if( isLabel ) {
            return " WIDTH FIRST " + getWidth()
        }
        if( !!position.width ) {
            return getWidth()
        }
        else if( !!position.height ) {
            return getHeight()
        }
        return `background-size: ${ div.width } ${ div.height }${isImportant ? "!important" : ""};`
    }

    const heightFirst = (): string => {
        if( isLabel ) {
            return " HEIGHT FIRST " + getHeight()
        }
        if( !!position.height ) {
            return getHeight()
        }
        else if( !!position.width ) {
            return getWidth()
        }
        return `background-size: ${ div.width } ${ div.height }${isImportant ? "!important" : ""};`
    } 

    if( (position.aspect || 1) < 1 && img.aspect < 1 ) {
        if( (position.aspect || 1) >= img.aspect ) {
            //console.log( 1.1 )
            return widthFirst() + ( isLabel ? " 1.1" : "")
        }
        if( (position.aspect || 1) < img.aspect ) {
            //console.log( 1.2 )
            return heightFirst() + ( isLabel ? " 1.2" : "")
        }
    }
    else if( (position.aspect || 1) >= 1 && img.aspect >= 1 ) {
        if( (position.aspect || 1) < img.aspect ) {
            //console.log( 2.1 )
            return heightFirst() + ( isLabel ? " 2.1" : "")
        }
        if( (position.aspect || 1) >= img.aspect ) {
            //console.log( 2.2 )
            return widthFirst() + ( isLabel ? " 2.2" : "")
        }
    }
    else if( (position.aspect || 1) >= 1 && img.aspect < 1 ) {
        if( (position.aspect || 1) < img.aspect ) {
            //console.log( 3.1 )
            return heightFirst() + ( isLabel ? " 3.1" : "")
        }
        if( (position.aspect || 1) >= img.aspect ) {
            //console.log( 3.2 )
            return widthFirst() + ( isLabel ? " 3.2" : "")
        }
    }
    else if( (position.aspect || 1) < 1 && img.aspect >= 1 ) {
        if( (position.aspect || 1) < img.aspect ) {
            //console.log( 4.1 )
            return heightFirst() + ( isLabel ? " 4.2" : "")
        }
        if( (position.aspect || 1) >= img.aspect ) {
            //console.log( 4.2 )
            return widthFirst() + ( isLabel ? " 4.1" : "")
        }
    }
     
    return str
}